module.exports = {"350213001":"大嶝街道","350213002":"马巷街道","350213003":"新店街道","350213004":"凤翔街道","350213005":"民安街道","350213006":"香山街道","350213007":"金海街道","350213103":"新圩镇","350213111":"内厝镇","350213404":"大帽山农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350213.json
// module id = 1288
// module chunks = 0